<template>
    <div class="logo">
        <!-- <img src="../assets/images/logo2.png" /> -->
        <img class="logo3" src="../assets/images/logo-1.png" />
        <img class="logo2" src="../assets/images/logo-2.png" />
        
        <div class="ul">
            <div class="li"><input type="text" class="se-txt form-control" v-on:keyup.13="search()" v-model="text"/><div @click="text=''" v-if="text.replace(/ /g,'').length>0" class="fork"><svg viewBox="0 0 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30"></path></svg></div>
            <!-- </div><div class="li"><a target="_blank" :href="text.replace(/ /g,'').length==0?'javascript:;':('https://www.baidu.com/s?wd='+text)" class=" btn se-btn baidu">百度搜索</a></div><a target="_blank" :href="text.replace(/ /g,'').length==0?'javascript:;':('https://www.so.com/s?q='+text)" class=" btn se-btn s360">360搜索</a> -->
            </div><div class="li"><a target="_blank" :href="'https://www.baidu.com/s?wd='+text" class=" btn se-btn baidu">百度搜索</a></div><a target="_blank" :href="'https://www.so.com/s?q='+text" class=" btn se-btn s360">360搜索</a>
        </div>
        <a class="cserver" href="https://v60.livechatvalue.com/chat/chatClient/chatbox.jsp?companyID=80000805&configID=402&codeType=custom&enterurl=pt8.me" target="_blank"><img  src="../assets/images/cs.png" /></a>
    </div>
</template>

<script>
import QRCode from "qrcode";
    export default{
        data(){
            return {
                text:''
            }
        },
        methods:{
            search(){
                window.open('https://www.baidu.com/s?wd='+this.text)
            },
            makeQRCode(link="") {
                // margin :二维码安静区域宽度，值越小白边越小，默认4
                let ret = ''
                let segs = {
                    margin: "1",
                    errorCorrectionLevel: "H"
                }

                if(link){
                    QRCode.toDataURL(link, segs, function (err, url) {
                        ret = url;
                    });
                }
                return ret;
            }
        }
    }
</script>

<style scoped>
.pull-right {
    margin-top: 17px;
    cursor: pointer;
}

input {
    padding: 6px;
}

div .ul {
    display: inline;
    list-style-type: none;
    position: absolute;
    top: 38px;
    margin-left: 45px;
    vertical-align: top;
}

.logo3{
    position: relative;
    top: 10px;
}

.logo2{
    position: relative;
    top: -16px;
    left: 20px;
}

.se-txt {
    border-radius: 10px 0 0 10px;
    width: 375px;
    padding-left: 10px;
    padding-right: 25px;
    display: inline-block;
    height: 60px;
    line-height: 60px;
    vertical-align: top;
    font-size: 16px;
}

.fork{
    width: 20px;
    height: 20px;
    display: inline-block;
    position: absolute;
    right: 5px;    
    top: 20px;
	border-radius:10px;
	background:rgba(185, 185, 185, 0.7);
    cursor: pointer;
}

.fork svg{
    stroke: #000;    
}

.se-btn {
    vertical-align: top;
    width: 116px;
    background: rgb(174, 165, 125);
    color: #fff;
    border-radius: 0;
    outline: none;
    box-shadow: none;
    height: 60px;
    line-height: 60px;
    padding: 0;
    font-size: 20px;
}

.li {
    display: inline;
    position: relative;
}

.baidu{
background: #3385ff;
}

.s360 {
    border-radius: 0 10px 10px 0;
    background: #23ac38;
}
.cserver {
   position: absolute;
   top: 40px;
   right: 50px;
}
.cserver img{    
    animation: changeFlash 12s ease-out 0s infinite;
}

@keyframes changeFlash{
    0%{
        transform: scale(1,1) rotate(0deg);
    }
    40%{        
        transform: scale(1,1) rotate(0deg);
    }
    41%{        
        transform: scale(1.1,1.1) rotate(5deg);
    }
    43%{        
        transform: scale(1.1,1.1) rotate(-5deg);
    }
    44%{ 
        transform: scale(1,1) rotate(0deg);
    }
    45%{        
        transform: scale(1.1,1.1) rotate(5deg);
    }
    47%{        
        transform: scale(1.1,1.1) rotate(-5deg);
    }
    48%{ 
        transform: scale(1,1) rotate(0deg);
    }
  }
  @media screen and (max-width:768px){
    .cserver{
            width: 85px;
            position: absolute;
            top: 73px;
            right: 10px;

        }
    .a-top .logo1{
        height: 65px;
        top: 40px;
    }
    .logo{
        position: relative;
    }
    .a-top img.logo2{
        height: 25px;
        left: 70px;
        top: 25px;
    }
    .logo3{
            height: 50px;
            position: absolute;
            left: 5px;
        }
        .logo2{
             height: 20px;
        }
  }
</style>







// WEBPACK FOOTER //
// src/components/a.header.top.vue